import { SAFETY_COPY } from '@saesak/shared';
import { AppBar, Screen } from '@/components/layout';
import { Button, Card, EmptyState, ErrorNote, Spinner } from '@/components/ui';
import { useBlockMutations, useBlocks } from '@/lib/safety';
import { formatFullDate } from '@/lib/format';

/** 차단한 사용자 — 앱 설정 (§5.30). 해제하면 다시 쪽지를 주고받고 댓글도 보인다 */
export function BlocksPage() {
  const blocks = useBlocks();
  const { unblock } = useBlockMutations();

  return (
    <Screen>
      <AppBar title={SAFETY_COPY.blocksTitle} back />
      <div className="flex flex-col gap-3 p-4">
        <p className="text-sm text-ink-sub">{SAFETY_COPY.blocksHint}</p>
        {blocks.isPending && <Spinner />}
        {blocks.isError && <ErrorNote message="목록을 불러오지 못했어요." onRetry={() => void blocks.refetch()} />}
        {blocks.data?.length === 0 && <EmptyState title={SAFETY_COPY.blocksEmpty} />}
        {blocks.data?.map((row) => (
          <Card key={row.userId} className="flex items-center gap-3">
            <div className="min-w-0 flex-1">
              <p className="truncate font-semibold">{row.name}</p>
              <p className="text-sm text-ink-sub">{formatFullDate(row.createdAt)}부터</p>
            </div>
            <Button size="sm" variant="outline" loading={unblock.isPending} onClick={() => unblock.mutate(row.userId)}>
              {SAFETY_COPY.unblock}
            </Button>
          </Card>
        ))}
      </div>
    </Screen>
  );
}
